import React from 'react'
import { Table } from 'stylist'
import { pluckNodes } from 'utils/relay'

const renderData = (data, key) =>
  key.name.split('.').reduce((data, name) => {
    return typeof data[name] === 'boolean' ? data[name].toString() : data[name]
  }, data)

const ConnectionTable = ({
  connection,
  linkKey,
  fields,
  history,
  match: { url },
  onRowClick = (e, row) => history.push(`${url}/${row[linkKey]}`)
}) => (
  <Table data={pluckNodes(connection)}>
    <Table.Row onClick={onRowClick}>
      {fields.map(field => (
        <Table.Column
          dataKey={field.name}
          label={field.label || field.name}
          key={field.name}
          render={data => renderData(data, field)}
          {...field.props}
        />
      ))}
    </Table.Row>
  </Table>
)

ConnectionTable.defaultProps = { linkKey: 'id', fields: [] }

export default ConnectionTable



// WEBPACK FOOTER //
// ./src/components/ConnectionTable/index.js